class Canny {
    constructor(canny) {
        this.canny = canny;
    }
    render(options) {
        if (this.canny) {
            this.canny("render", options);
        }
    }
    initChangelog(options) {
        if (this.canny) {
            this.canny("initChangelog", options);
        }
    }
    closeChangelog() {
        if (this.canny) {
            this.canny("closeChangelog");
        }
    }
}
export { Canny };
